import { PortableTextComponentProps } from '@portabletext/react'
import cx from 'classnames'
import { useState, useContext } from 'react'

import { SanityAddToCartButton } from '@data/sanity/queries/types/content'
import { StringsContext } from '@lib/strings-context'

import Alert from '@components/alert'
import AddToCartButton from '@components/buttons/add-to-cart-button'
import {
  getButtonColor,
  getButtonIconAlignment,
  getButtonSize,
  getButtonVariant,
} from '@components/buttons/button'
import SimplePortableText from '@components/portable-text/simple'

type AddToCartButtonValue = Pick<
  SanityAddToCartButton,
  'productVariant' | 'text' | 'style'
>

const PortableTextAddToCartButton = ({
  value,
}: PortableTextComponentProps<AddToCartButtonValue>) => {
  const { productVariant, text, style } = value

  const strings = useContext(StringsContext)

  const [isAddToCartError, setIsAddToCartError] = useState(false)

  return (
    <>
      <AddToCartButton
        productVariant={productVariant}
        variant={getButtonVariant(style?.variant)}
        size={getButtonSize(style?.size)}
        color={getButtonColor(style?.color)}
        icon={style?.icon}
        iconAlignment={getButtonIconAlignment(style?.iconAlignment)}
        onAddToCartError={() => {
          setIsAddToCartError(true)
        }}
        className={cx('btn', {
          'w-full': style?.isFullWidth,
        })}
      >
        {text}
      </AddToCartButton>

      {isAddToCartError && (
        <div key="error" className="mt-2">
          <Alert error>
            <SimplePortableText
              content={strings.cartAddToCartErrorMessage}
              className="rc rc-error"
            />
          </Alert>
        </div>
      )}
    </>
  )
}

export default PortableTextAddToCartButton
